var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "640px", persistent: "", scrollable: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("div", { staticClass: "title--text" }, [_vm._v("Đăng ký")]),
              _c("v-spacer"),
              _c(
                "v-icon",
                {
                  staticClass: "mr-n1",
                  on: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v("mdi-close")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "pt-4 pb-2" },
            [
              _c(
                "v-form",
                { ref: "form" },
                [
                  _c(
                    "div",
                    { staticClass: "text-subtitle-1 font-weight-medium mb-4" },
                    [_vm._v(" TÀI KHOẢN ĐĂNG KÝ TUYỂN SINH KHỐI 10 ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Họ và tên học sinh "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "VD: Nguyễn Văn A",
                          name: "login",
                          color: "primary",
                          hint: "Gõ tiếng Việt có dấu, đúng quy tắc viết hoa",
                          "persistent-hint": "",
                          rules: [
                            _vm.$rules.required,
                            _vm.$rules.vietnameseName
                          ],
                          outlined: ""
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.submit.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.studentName,
                          callback: function($$v) {
                            _vm.studentName = $$v
                          },
                          expression: "studentName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("Ngày tháng năm sinh "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c(
                    "div",
                    { staticClass: "mb-8" },
                    [
                      _c("DobSplitInput", {
                        ref: "date-picker",
                        model: {
                          value: _vm.dob,
                          callback: function($$v) {
                            _vm.dob = $$v
                          },
                          expression: "dob"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Mã định danh cá nhân/Căn cước công dân "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "############",
                            expression: "'############'"
                          }
                        ],
                        attrs: {
                          placeholder: "Nhập thông tin tại đây",
                          name: "login",
                          color: "primary",
                          hint:
                            "Gồm 12 số theo giấy khai sinh hoặc theo Căn cước công dân do cơ quan công an cấp",
                          "persistent-hint": "",
                          rules: [
                            _vm.$rules.required,
                            _vm.$rules.minLengthBGD(12)
                          ],
                          outlined: ""
                        },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.submit.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.studentCode,
                          callback: function($$v) {
                            _vm.studentCode = $$v
                          },
                          expression: "studentCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      " Địa chỉ thường trú (Số nhà, Đường/Phố, Xã/Phường, Thành phố) "
                    ),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder:
                        "VD: Số 17 Đường Hoàng Hoa Thám, Phường Ngô Quyền, Thành phố Hà Nội",
                      name: "login",
                      color: "primary",
                      rules: [_vm.$rules.required],
                      outlined: ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submit.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  }),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      " Thông tin trường đang học (Vui lòng chọn thông tin dưới đây) "
                    ),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-autocomplete", {
                    attrs: {
                      items: [..._vm.provinces, _vm.otherProvinceText],
                      "item-text": "name",
                      "item-value": "name",
                      "menu-props": { maxHeight: 120 },
                      outlined: "",
                      clearable: "",
                      "return-object": false,
                      rules: [_vm.$rules.required],
                      autocomplete: "on",
                      placeholder: "Thành phố Hà Nội hoặc Tỉnh/Thành phố khác",
                      "no-data-text": "Không tìm thấy Tỉnh/Thành phố phù hợp"
                    },
                    model: {
                      value: _vm.selectedProvince,
                      callback: function($$v) {
                        _vm.selectedProvince = $$v
                      },
                      expression: "selectedProvince"
                    }
                  }),
                  _vm.selectedProvince === _vm.otherProvinceText
                    ? _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          placeholder: "Nhập tên Tỉnh/Thành phố tại đây",
                          rules: [
                            v =>
                              _vm.selectedProvince !== _vm.otherProvinceText ||
                              !!v ||
                              "Vui lòng nhập Tỉnh/Thành phố"
                          ]
                        },
                        model: {
                          value: _vm.otherProvince,
                          callback: function($$v) {
                            _vm.otherProvince = $$v
                          },
                          expression: "otherProvince"
                        }
                      })
                    : _vm._e(),
                  _vm.selectedProvince !== _vm.otherProvinceText
                    ? _c("v-autocomplete", {
                        attrs: {
                          items: _vm.filteredWards,
                          "item-text": "name",
                          "item-value": "name",
                          "menu-props": { maxHeight: 120 },
                          outlined: "",
                          clearable: "",
                          "return-object": false,
                          rules: [_vm.$rules.required],
                          autocomplete: "on",
                          placeholder: "Chọn Phường hoặc Xã",
                          "no-data-text": "Không tìm thấy Phường/Xã phù hợp"
                        },
                        model: {
                          value: _vm.selectedWard,
                          callback: function($$v) {
                            _vm.selectedWard = $$v
                          },
                          expression: "selectedWard"
                        }
                      })
                    : _vm._e(),
                  _vm.selectedProvince === _vm.otherProvinceText
                    ? _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          placeholder: "Nhập Phường/Xã tại đây",
                          rules: [v => !!v || "Vui lòng nhập Phường/Xã"]
                        },
                        model: {
                          value: _vm.otherWard,
                          callback: function($$v) {
                            _vm.otherWard = $$v
                          },
                          expression: "otherWard"
                        }
                      })
                    : _vm._e(),
                  _vm.selectedProvince !== _vm.otherProvinceText
                    ? _c("v-autocomplete", {
                        attrs: {
                          items: [
                            ..._vm.filterSchools,
                            { name: _vm.otherText, value: "other" }
                          ],
                          "item-text": "name",
                          "item-value": "name",
                          "menu-props": { maxHeight: 120 },
                          outlined: "",
                          clearable: "",
                          "return-object": false,
                          rules: [_vm.$rules.required],
                          autocomplete: "on",
                          placeholder: "Chọn Tên trường",
                          "no-data-text": "Không tìm thấy trường phù hợp"
                        },
                        model: {
                          value: _vm.studentSchool,
                          callback: function($$v) {
                            _vm.studentSchool = $$v
                          },
                          expression: "studentSchool"
                        }
                      })
                    : _vm._e(),
                  _vm.studentSchool === _vm.otherText ||
                  _vm.selectedProvince === _vm.otherProvinceText
                    ? _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          placeholder: "Nhập tên trường tại đây",
                          rules: [
                            v =>
                              _vm.studentSchool !== _vm.otherText ||
                              !!v ||
                              "Vui lòng nhập tên trường"
                          ]
                        },
                        model: {
                          value: _vm.otherStudentSchool,
                          callback: function($$v) {
                            _vm.otherStudentSchool = $$v
                          },
                          expression: "otherStudentSchool"
                        }
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(" Nguyện vọng 1 trường cấp 3 "),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*")
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#707070", "font-size": "12px" }
                      },
                      [_vm._v(" (Dự kiến)")]
                    )
                  ]),
                  _c("v-autocomplete", {
                    attrs: {
                      items: [
                        ..._vm.expectOptions,
                        { name: _vm.otherText, value: "other" }
                      ],
                      "item-text": "name",
                      "item-value": "name",
                      "menu-props": { maxHeight: 120 },
                      outlined: "",
                      clearable: "",
                      "return-object": false,
                      rules: [_vm.$rules.required],
                      autocomplete: "on",
                      placeholder: "Bắt đầu gõ để tìm kiếm...",
                      "no-data-text": "Không tìm thấy trường phù hợp"
                    },
                    model: {
                      value: _vm.expectSchool,
                      callback: function($$v) {
                        _vm.expectSchool = $$v
                      },
                      expression: "expectSchool"
                    }
                  }),
                  _vm.expectSchool === _vm.otherText
                    ? _c("v-text-field", {
                        attrs: {
                          outlined: "",
                          placeholder: "Nhập tên trường tại đây",
                          rules: [
                            v =>
                              _vm.expectSchool !== _vm.otherText ||
                              !!v ||
                              "Vui lòng nhập tên trường"
                          ]
                        },
                        model: {
                          value: _vm.otherExpectSchool,
                          callback: function($$v) {
                            _vm.otherExpectSchool = $$v
                          },
                          expression: "otherExpectSchool"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Điểm trung bình môn Toán học kì 1 lớp 9"),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Nhập điểm tại đây",
                          name: "login",
                          color: "primary",
                          type: "number",
                          outlined: ""
                        },
                        model: {
                          value: _vm.mathScore,
                          callback: function($$v) {
                            _vm.mathScore = $$v
                          },
                          expression: "mathScore"
                        }
                      }),
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v(" Điểm trung bình môn Tiếng Anh học kì 1 lớp 9"),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Nhập điểm tại đây",
                          name: "login",
                          color: "primary",
                          type: "number",
                          outlined: ""
                        },
                        model: {
                          value: _vm.englishScore,
                          callback: function($$v) {
                            _vm.englishScore = $$v
                          },
                          expression: "englishScore"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-4" },
                    [
                      _c("div", { staticClass: "text-subtitle-1" }, [
                        _vm._v("Họ tên phụ huynh "),
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*")
                        ])
                      ]),
                      _c("v-text-field", {
                        attrs: {
                          placeholder: "Nhập tên phụ huynh tại đây",
                          name: "login",
                          hint: "Gõ tiếng Việt có dấu, đúng quy tắc viết hoa",
                          "persistent-hint": "",
                          color: "primary",
                          rules: [
                            _vm.$rules.required,
                            _vm.$rules.vietnameseName
                          ],
                          outlined: ""
                        },
                        model: {
                          value: _vm.parentName,
                          callback: function($$v) {
                            _vm.parentName = $$v
                          },
                          expression: "parentName"
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(" Số điện thoại PH "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "mask",
                        rawName: "v-mask",
                        value: "##########",
                        expression: "'##########'"
                      }
                    ],
                    attrs: {
                      placeholder:
                        "Nhập số điện thoại tại đây (Ví dụ: 097372xxxx)",
                      name: "login",
                      type: "tel",
                      color: "primary",
                      rules: _vm.phoneRules,
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submit.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.phone,
                      callback: function($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  }),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("Email liên hệ "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "VD: abcxyz@gmail.com",
                      name: "login",
                      color: "primary",
                      rules: [_vm.$rules.required, _vm.$rules.email],
                      outlined: ""
                    },
                    model: {
                      value: _vm.parentEmail,
                      callback: function($$v) {
                        _vm.parentEmail = $$v
                      },
                      expression: "parentEmail"
                    }
                  }),
                  _c("v-divider"),
                  _c(
                    "div",
                    {
                      staticClass: "text-subtitle-1",
                      staticStyle: { "margin-top": "22px" }
                    },
                    [
                      _vm._v("Mật khẩu "),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*")
                      ])
                    ]
                  ),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "PH tự tạo mật khẩu",
                      color: "primary",
                      "append-icon": _vm.showPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showPassword ? "text" : "password",
                      rules: _vm.passwordRules,
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showPassword = !_vm.showPassword
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submit.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  }),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("Mật khẩu (nhắc lại) "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Nhập mật khẩu tại đây",
                      "append-icon": _vm.showConfirmPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showConfirmPassword ? "text" : "password",
                      rules: _vm.confirmPasswordRules,
                      color: "primary",
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showConfirmPassword = !_vm.showConfirmPassword
                      },
                      keyup: [
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.submit.apply(null, arguments)
                        },
                        function($event) {
                          return _vm.$refs.form.validate()
                        }
                      ]
                    },
                    model: {
                      value: _vm.confirmPassword,
                      callback: function($$v) {
                        _vm.confirmPassword = $$v
                      },
                      expression: "confirmPassword"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            { staticStyle: { "flex-direction": "column" } },
            [
              _c(
                "div",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text text-subtitle-1 mt-4 text-none",
                      staticStyle: { width: "100%" },
                      attrs: {
                        depressed: "",
                        "x-large": "",
                        color: "primary",
                        loading: _vm.loading
                      },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("Đăng ký")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "text-subtitle-1 font-weight-bold mt-2 text-none",
                      staticStyle: { width: "100%" },
                      attrs: { plain: "", "x-large": "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.signin()
                        }
                      }
                    },
                    [_vm._v("Đã có tài khoản? Đăng nhập")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }